{
    "status": {
        "due": "Da fare",
        "overdue": "In ritardo",
        "completed": "Completato"
    },
    "blankAnswer": "Non indicato",
    "list": {
        "title": "Diari",
        "emptyTitle": "Nessun diario per il momento",
        "emptyDescription": "I diari creati per Lei compariranno qui",
        "checkAgain": "Controlla di nuovo",
        "needsAttention": "Richiede la Sua attenzione",
        "needsAttentionDesc": "Diari i cui moduli attendono il Suo prossimo inserimento.",
        "upToDate": "Aggiornato",
        "ongoing": "In corso",
        "ongoingDesc": "Diari in corso o in attesa del Suo primo inserimento.",
        "upToDateDesc": "Diari in corso senza inserimenti da effettuare.",
        "noOngoing": "Nessun diario in corso per il momento",
        "completed": "Completati",
        "completedDesc": "Diari chiusi (non viene più registrato alcun inserimento).",
        "noCompleted": "Nessun diario completato per il momento",
        "openDiary": "Apri il diario",
        "reviewDiary": "Consulta il diario"
    },
    "goToDiaries": {
        "title": "Vai a {{diaryWord}}",
        "actionRequiredCount": "Azione richiesta ({{count}})",
        "actionRequiredOneForm": "Azione richiesta ({{count}} modulo)",
        "actionRequiredManyForms": "Azione richiesta ({{count}} moduli)",
        "defaultDescription": "I diari sono i Suoi monitoraggi sanitari personali e aiutano a migliorare le cure e la ricerca.",
        "oneFormDue": "Ha {{count}} modulo da compilare.",
        "manyFormsDue": "Ha {{count}} moduli da compilare.",
        "diariesNeedAttention": "Ha {{count}} {{diaryWord}} i cui moduli richiedono la Sua attenzione."
    }
}
